import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, nextTick, ref, watch } from "vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import PromoContent from "./_promo-content.vue";


export default /*@__PURE__*/_defineComponent({
  __name: '_promo-content-widget',
  setup(__props) {

const contentIsInViewport = ref(false);

const wrapperElem = document.getElementById("random-recommendation-card-wrapper");
const cardElem = document.getElementById("random-recommendation-card");

const isMobile = computed(() => !useBreakpoints("xs2").value);
const ticketFilterIsActive = ref(false);
const showWidget = computed(() => !isMobile.value || !ticketFilterIsActive.value);

eventBus.on(GlobalEvents.TicketFilterActive, () => {
    ticketFilterIsActive.value = true;
});

eventBus.on(GlobalEvents.TicketFilterInactive, () => {
    ticketFilterIsActive.value = false;
});

watch(showWidget, (shouldBeVisible) => {
    if (!cardElem) return;

    if (shouldBeVisible) {
        cardElem.classList.remove("d-none");
    } else {
        cardElem.classList.add("d-none");
    }
});

const initSlider = () => {
    if (!wrapperElem) {
        contentIsInViewport.value = true;
        return;
    }

    nextTick(() => {
        onViewportEnter(wrapperElem, 0).then(() => {
            contentIsInViewport.value = true;
        });
    });
};

initSlider();

return (_ctx: any,_cache: any) => {
  return (contentIsInViewport.value)
    ? (_openBlock(), _createBlock(PromoContent, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})